<div
        aria-labelledby="inlcudes-tab"
        class="tab-pane tab-content fade"
        id="inlcudes"
        role="tabpanel"
>
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="error-list" v-if="ui.error.error_message">
            <ul class="error-msg">
                <li :key="x" v-for="(error,x) in ui.error.error_message">
                    <div :key="i" v-for="(err,i) in error">
                        <p>{{err}}</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="content-block">
            <form>
                <div class="form-modified">
                    <div class="row">
                        <div class="col-lg-8 offset-2">
                            <div class="empty-data green">
                                <p>
                                    You can add, edit, or delete the details that are inclusive on
                                    the price or package.
                                </p>
                            </div>
                            <div class="mb-3" v-if="!ui.status.canAdd  && permission.trekInclude_add">
                                <a
                                        @click.prevent="showAddIncludeButton()"
                                        class="btn default-btn"
                                        href=""
                                ><i class="fas fa-plus"></i> Add new include</a
                                >
                            </div>
                        </div>
                    </div>

                    <div class="form-group row" v-if="ui.status.canAdd">
                        <label class="col-sm-2 col-form-label" for="staticEmail">
                            Includes</label
                        >
                        <div class="col-sm-8">
                            <div class="form-group">
                <textarea
                        :class="{ 'error-input' : ui.error.errors['title'] }"
                        id=""
                        name=""
                        placeholder="eg. Include Here."
                        v-model="item.addInclude.title"
                ></textarea>
                                <validation-error
                                        :errors="ui.error.errors"
                                        :field="'title'"
                                        :isError="ui.error.has_error"
                                        v-if="ui.error.has_error"
                                />
                            </div>

                            <div class="form-group">
                                <div class="multiselect-input" v-if="getAllIconsList">
                                    <multiselect
                                            :class="{ 'error-input' : ui.error.errors['icon_id'] }"
                                            :custom-label="customLabel"
                                            :option-height="40"
                                            :options="getAllIconsList"
                                            :show-labels="false"
                                            :track-by="'name'"
                                            label="name"
                                            placeholder="Choose icon"
                                            v-model="item.addInclude.icon"
                                    >
                                        <template slot="singleLabel" slot-scope="props"
                                        ><img
                                                :src="props.option.icon_path"
                                                alt="No Man’s Sky"
                                                class="option__image"
                                        /><span class="option__desc"
                                        ><span class="option__title"
                                        >{{ props.option.name }}</span
                                        ></span
                                        ></template
                                        >
                                        <template slot="option" slot-scope="props"
                                        ><img
                                                :src="props.option.icon_path"
                                                alt="No Man’s Sky"
                                                class="option__image"
                                        />
                                            <div class="option__desc">
                        <span class="option__title"
                        >{{ props.option.name }}</span
                        >
                                            </div>
                                        </template>
                                    </multiselect>
                                    <validation-error
                                            :errors="ui.error.errors"
                                            :field="'icon_id'"
                                            :isError="ui.error.has_error"
                                            v-if="ui.error.has_error"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2" v-if="permission.trekInclude_add">
                            <a
                                    @click.prevent="addIncludes"
                                    class="btn btn-sm add-btn"
                                    href="#"
                                    role="button"
                            >{{buttonTextAddInclude}}
                                <spinner
                                        :loading="ui.status.postLoading.create"
                                        v-if="ui.status.postLoading.create"
                                ></spinner>
                            </a>
                        </div>
                    </div>
                    <div
                            :key="index"
                            class="form-group row"
                            v-for="(list, index) in item.includesList"
                    >
                        <div class="col-lg-8 offset-lg-2">
                            <div class="empty-data">
                                <p v-if="item.includesList.length == 0">
                                    No includes List
                                </p>
                            </div>

                            <div class="includes-list-item">
                                <div
                                        class="includes-list hoverable-list readonly"
                                        v-if="!list.IsActive"
                                >
                                    <!-- <label class="readonly"><span v-if="list.icon">{{list.icon.name}}</span></label> -->
                                    <div class="list-ico">
                                        <img :src="list.icon.icon_path" v-if="list.icon"/>
                                    </div>
                                    <div class="includes-description">
                                        <p>{{ list.title }}</p>
                                    </div>

                                    <div class="up-down">
                                        <button
                                                @click.prevent="moveIncludeUp(index, list)"
                                                class="btn arrange-btn"
                                                v-if="index != 0"
                                        >
                                            <i class="fas fa-level-up-alt"></i>
                                        </button>
                                        <button
                                                @click.prevent="moveIncludeDown(index, list)"
                                                class="btn arrange-btn"
                                                v-if="index !== item.includesList.length -1"
                                        >
                                            <i class="fas fa-level-down-alt"></i>
                                        </button>
                                    </div>

                                    <!-- delete modals -->
                                </div>

                                <div class="includes-list editable" v-if="list.IsActive">
                                    <div class="row">
                                        <div class="col-lg-10">
                                            <div class="form-group">
                        <textarea
                                :class="{ 'error-input' : ui.error.errors['edit_title'] }"
                                id=""
                                name=""
                                placeholder="eg. Include Here."
                                v-model="list.title"
                        ></textarea>
                                                <validation-error
                                                        :errors="ui.error.errors"
                                                        :field="'edit_title'"
                                                        :isError="ui.error.has_error"
                                                        v-if="ui.error.has_error"
                                                />

                                            </div>

                                            <div class="form-group">
                                                <div
                                                        class="multiselect-input"
                                                        v-if="getAllIconsList"
                                                >
                                                    <multiselect
                                                            :class="{ 'error-input' : ui.error.errors['edit_icon_id'] }"
                                                            :custom-label="customLabel"
                                                            :option-height="40"
                                                            :options="getAllIconsList"
                                                            :show-labels="false"
                                                            :track-by="'name'"
                                                            label="name"
                                                            placeholder="Choose icon"
                                                            v-model="list.icon"
                                                    >
                                                        <template slot="singleLabel" slot-scope="props"
                                                        ><img
                                                                :src="props.option.icon_path"
                                                                alt="No Man’s Sky"
                                                                class="option__image"
                                                        /><span class="option__desc"
                                                        ><span class="option__title"
                                                        >{{ props.option.name }}</span
                                                        ></span
                                                        >
                                                        </template>
                                                        <template slot="option" slot-scope="props"
                                                        ><img
                                                                :src="props.option.icon_path"
                                                                alt="No Man’s Sky"
                                                                class="option__image"
                                                        />
                                                            <div class="option__desc">
                                <span class="option__title"
                                >{{ props.option.name }}</span
                                >
                                                            </div>
                                                        </template>
                                                    </multiselect>
                                                    <validation-error
                                                            :errors="ui.error.errors"
                                                            :field="'edit_icon_id'"
                                                            :isError="ui.error.has_error"
                                                            v-if="ui.error.has_error"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-lg-2">
                                            <div class="includes-action justify-content-start">
                                                <button
                                                        @click.prevent="editIncludes()"
                                                        class="btn green"
                                                        type="button"
                                                        v-if="list.IsActive"
                                                >
                                                    <i class="fas fa-save"></i>
                                                </button>
                                                <button
                                                        @click.prevent="cancelIncludes(index, list)"
                                                        class="btn red"
                                                        type="button"
                                                        v-if="list.IsActive"
                                                >
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2">
                            <div class="includes-action">
                                <button
                                        @click.prevent="onEditIncludesClick(index, list)"
                                        class="btn blue"
                                        type="button"
                                        v-if="!ui.status.canEdit  && permission.trekInclude_edit"
                                >
                                    <i class="fas fa-pen"></i>
                                </button>
                                <button
                                        @click.prevent="onDeleteIncludesClick(index, list)"
                                        class="btn red"
                                        type="button"
                                >
                                    <i class="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <div class="modal-wrap">
                <div
                        aria-labelledby="exampleModalLabel"
                        class="modal fade show"
                        id="deleteSelectedIncludes"
                        role="dialog"
                        tabindex="-1"
                >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Delete Include</h5>
                                <button
                                        aria-label="Close"
                                        class="close"
                                        data-dismiss="modal"
                                        type="button"
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div class="error-list" v-if="ui.error.modal.delete">
                                <ul class="error-msg">
                                    <li :key="x" v-for="(error,x) in ui.error.modal.delete">
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                            <div class="modal-body">
                                <p>
                                    Are you sure you want to delete this ?
                                </p>
                            </div>

                            <div class="modal-footer">
                                <button
                                        @click.prevent="deleteIncludes()"
                                        class="btn default-btn"
                                        type="button"
                                >
                                    Ok
                                    <spinner :loading="ui.status.postLoading.delete" v-if="ui.status.postLoading.delete"></spinner>
                                </button>
                                <button
                                        :disabled="ui.status.postLoading.delete"
                                        @click.prevent="hideDeleteModal"
                                        aria-label="Close"
                                        class="btn default-btn cancel" type="button"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
